import { SearchTriggerType } from 'pf-frontend-common/src/module/stats/types';

import { BrokerSerpStoreStateInterface } from 'common/module/broker-serp/store/state.interface';
import { BrokerSerpStoreStateParamsInterface } from 'common/module/broker-serp/store/state-params.interface';
import { BrokerSerpStoreStateResultsInterface } from 'common/module/broker-serp/store/state-results.interface';
import { BrokerSerpStoreOptionsInterface } from 'common/module/broker-serp/store-options.interface';
import { DataStore } from 'common/module/data/store';

export class BrokerSerpStore extends DataStore {
  /**
   * Store state
   */
  protected state: BrokerSerpStoreStateInterface = {
    trigger: 'initial',
    params: {
      'page[number]': 1,
      'page[limit]': 20,
    },
    results: {
      count: 0,
      list: [],
    },
    inputs: {
      sort: [],
    },
  };

  /**
   * @inheritDoc
   */
  public initialize(options: BrokerSerpStoreOptionsInterface): void {
    if (options.form) {
      this.state.params['filter[name]'] = options.form.text || '';
      this.state.params['filter[location_id]'] = options.form.locationId || '';
      this.state.params['filter[id]'] = options.form.id || '';
      this.state.params.sort = options.form.orderBy || options.form.sort[0].id;

      this.state.inputs.sort = options.form.sort.map((option) => ({
        value: option.id,
        text: option.text,
      }));
    }

    if (options.searchOutput) {
      this.state.params['page[number]'] = options.searchOutput.pagination.page;
      this.state.results.count = options.searchOutput.pagination.totalCount;
      this.state.results.list = options.searchOutput.brokers.map((brokerModel) => brokerModel.id);
    }
  }

  /**
   * @inheritDoc
   */
  public getState(): BrokerSerpStoreStateInterface {
    return this.state;
  }

  /**
   * Update params
   *
   * @param silent - if true, won't propagate state update event
   */
  public updateParams(
    payload: BrokerSerpStoreStateParamsInterface,
    trigger?: SearchTriggerType,
    silent?: boolean
  ): Promise<void> {
    const state = {
      ...this.getState(),
      trigger: trigger || 'update',
      params: {
        ...this.getState().params,
        ...payload,
      },
    };

    if (silent) {
      this.state = state;

      return Promise.resolve();
    }
    this.setState(state, this.updateParams);

    return Promise.resolve();
  }

  /**
   * Update the results list based on API results
   */
  public updateResults(payload: BrokerSerpStoreStateResultsInterface): Promise<void> {
    const state = this.getState();

    state.results.count = payload.count;
    state.results.list = payload.list;

    this.setState(state, this.updateResults);

    return Promise.resolve();
  }
}
